import { isItalianTenant, loc } from "../../../../../core/utils"
import { number, string } from "prop-types"
import React from "react"
import { Col } from "react-bootstrap"
export default function PricePerMonth({
  servicePackPriceFromRentAmount,
  servicePackPriceFromRentMessage,
  tenant,
  duration,
  monthlyTotal,
  oldPrice,
  simplified = false
}) {

  if (simplified) {
    return (
      <>
        <Col>
          <p>
            {loc('Rent')} : { monthlyTotal }
            {!isItalianTenant(tenant) && servicePackPriceFromRentAmount > 0 && (
              <i>
                <small>
                  {" "}
                  ({loc`including services at`} {servicePackPriceFromRentMessage} {loc`/month`})
                </small>
              </i>
            )}
          </p>
        </Col>
      </>
    )
  }

  return (
    <>
      <Col>
        <p className="text-inline">
          {isItalianTenant(tenant)
            ? `${loc`Rent`} (${duration || 0})`
            : `${loc`Rent`} ${loc`on`} ${duration || 0} ${loc`months`}`
          }
          {!isItalianTenant(tenant) && servicePackPriceFromRentAmount > 0 && (
            <i>
              <small>
                {" "}
                ({loc`including services at`} {servicePackPriceFromRentMessage} {loc`/month`})
              </small>
            </i>
          )}
        </p>
      </Col>
      <Col>
        {oldPrice ? (
          <div className="tradein-price-container">
            <div className="tradein-old-price text-right">
              <s className="strike">{oldPrice} <small>{loc`/month`}</small></s>
            </div>
            <div className="tradein-new-price text-right">
              {monthlyTotal} <small>{loc`/month`}</small>
            </div>
          </div>
        ) : (
          <p className="text-right">
            {monthlyTotal} <small>{loc`/month`}</small>
          </p>
        )}
      </Col>
    </>
  )
}

PricePerMonth.propTypes = {
  servicePackPriceFromRentAmount: number,
  servicePackPriceFromRentMessage: string,
  tenant: string,
  duration: number,
  monthlyTotal: string,
  oldPrice: string
}
